import { BrowserRouter } from 'react-router-dom'
import { useEffect } from 'react'
import { AppRoutes } from './router'
import ScrollToTop from './components/ScrollToTop'
import CookieConsent from './components/cookie/CookieConsent'
import WalletStatusBar from './components/wallet/WalletStatusBar'
import ErrorBoundary from './components/ErrorBoundary'
import DarkModeProvider from './components/DarkModeProvider'
import SkipToContent from './components/common/SkipToContent'
import { cookieManager } from './utils/cookieManager'
import { initSmoothScroll } from './utils/smoothScroll'
import { getWebsiteStructuredData, getOrganizationStructuredData } from './components/common/StructuredData'
import StructuredData from './components/common/StructuredData'
import { envConfig, logEnvConfig, validateEnvConfig } from './config/env'
import { performanceMonitor } from './utils/performanceMonitor'

function App() {
  useEffect(() => {
    // 初始化平滑滚动
    initSmoothScroll();

    // 验证环境变量配置
    const envValidation = validateEnvConfig();
    if (!envValidation.isValid) {
      console.warn('⚠️ Missing required environment variables:', envValidation.missing);
    }

    // 记录环境配置（仅开发模式）
    logEnvConfig();

    // 性能监控定期报告
    const reportInterval = setInterval(() => {
      const report = performanceMonitor.generateReport();
      if (envConfig.enableErrorReporting) {
        performanceMonitor.sendReport(report);
      }
    }, 60000); // 每分钟报告一次

    // 页面卸载时清理
    return () => {
      clearInterval(reportInterval);
    };
  }, []);

  const handleCookieAccept = (preferences: any) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('Cookie preferences accepted:', preferences);
    }
    
    // 如果用户同意分析Cookie，初始化Google Analytics
    if (preferences.analytics) {
      // 这里可以添加您的Google Analytics测量ID
      // cookieManager.initializeGoogleAnalytics('GA_MEASUREMENT_ID');
    }
  };

  const handleCookieReject = () => {
    if (process.env.NODE_ENV === 'development') {
      console.log('All cookies rejected except necessary ones');
    }
    cookieManager.clearNonEssentialCookies();
  };

  return (
    <ErrorBoundary>
      <DarkModeProvider>
        {/* SEO 结构化数据 */}
        <StructuredData type="WebSite" data={getWebsiteStructuredData()} />
        <StructuredData type="Organization" data={getOrganizationStructuredData()} />
        
        <BrowserRouter basename={__BASE_PATH__}>
          <SkipToContent />
          <ScrollToTop />
          <WalletStatusBar />
          <AppRoutes />
          <CookieConsent 
            onAccept={handleCookieAccept}
            onReject={handleCookieReject}
          />
        </BrowserRouter>
      </DarkModeProvider>
    </ErrorBoundary>
  )
}

export default App